<template>
  <a-modal :title="displayTitle" v-model="visible" @ok="handleOK">
    <a-form-item
      label="名称"
      labelAlign="left"
      :labelCol="{ span: 4 }"
      :wrapperCol="{ span: 12 }"
    >
      <a-input v-model="name" class="save-preset-input" />
    </a-form-item>
    <a-form-item
      label="预览图"
      labelAlign="left"
      :labelCol="{ span: 4 }"
      :wrapperCol="{ span: 12 }"
    >
      <a-button
        class="save-preset-upload"
        :style="url ? { backgroundImage: `url(${url})` } : {}"
        @click="handleClick"
        :class="{ 'save-preset-upload--empty': !url }"
      >
        <div
          class="save-preset-upload__inner"
          :class="{ 'save-preset-upload__inner--overlay': url }"
        >
          <a-icon
            :type="url ? 'reload' : 'plus'"
            class="save-preset-upload__icon"
          />
          {{ url ? "更换" : "上传图片" }}
        </div>
      </a-button>
    </a-form-item>
  </a-modal>
</template>
<script>
import { message, Modal } from 'ant-design-vue';
import { uploadFile2 } from '../../utils/api';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      name: '',
      url: ''
    };
  },
  computed: {
    ...mapState(['savePresetType']),
    visible: {
      get() {
        return this.$store.state.savePresetShowing;
      },
      set(value) {
        if (value) {
          this.$store.commit('handleSavePresetShow', value);
        } else {
          this.close();
        }
      }
    },
    displayTitle() {
      switch (this.savePresetType) {
        case 'preset':
          return '组件素材共享';
        case 'combination':
          return '组合文本共享';
      }

      return 'Unsupported Action';
    },
    defaultName() {
      switch (this.savePresetType) {
        case 'preset':
          return '组件素材';
        case 'combination':
          return '组合文本';
      }

      return 'Unsupported Default Name';
    }
  },
  methods: {
    handleClick() {
      if (this.input) {
        this.input.click();
      }
    },
    async handleUpload(e) {
      try {
        if (e.target.files.length) {
          const file = e.target.files[0];
          const { url } = await uploadFile2(file);
          this.url = url;
          console.log(url);
        }
      } catch (e) { }
      e.target.value = '';
    },
    close() {
      this.$store.commit('handleSavePresetShow', false);
    },
    async handleOK() {
      if (this.name && this.url) {
        await this.$store.dispatch('saveSelectionToPreset', {
          name: this.name,
          url: this.url,
          type: this.savePresetType
        });
        message.info('添加完成');
        this.close();
      } else {
        Modal.error({
          title: '部分字段为空',
          content: '请添加名称和预览图。'
        });
      }
    }
  },
  mounted() {
    const inputEl = document.createElement('input');
    inputEl.type = 'file';
    inputEl.style.width = '1px';
    inputEl.className = 'effect-cover__measure';
    inputEl.accept = '.jpg,.jpeg,.png';

    inputEl.onchange = this.handleUpload;
    document.body.appendChild(inputEl);
    this.input = inputEl;
  },
  watch: {
    visible(val) {
      if (val) {
        this.name = this.defaultName;
        this.url = '';
      }
    }
  },
  beforeDestroy() {
    document.body.removeChild(this.input);
  }
}
</script>
<style scoped>
.save-preset-upload {
  display: block;
  width: 104px;
  height: 104px;
  border: 0;
  border-radius: 2px;
  position: relative;
  background: transparent center no-repeat;
  background-size: cover;
}

.save-preset-upload--empty {
  border: 1px dashed rgba(0, 0, 0, 0.15);
}

.save-preset-upload__inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  --icon-color: #007eff;
}

.save-preset-upload__inner--overlay {
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  --icon-color: #fff;
  border-radius: 2px;
  transition: 0.2s;
}

.save-preset-upload:focus .save-preset-upload__inner--overlay,
.save-preset-upload:hover .save-preset-upload__inner--overlay {
  background-color: rgba(0, 0, 0, 0.6);
}

.save-preset-upload__icon {
  color: var(--icon-color);
  margin-bottom: 4px;
  font-size: 20px;
}
</style>